import { ApiResponseData } from "../../services/YourAppServer/YourAppServerApi.service";

// Requests
export class GetNewVersionModel {
  public platform: string;
  public version: string;
}

// Responses
export class VersionModel implements ApiResponseData {
  public version: string;
  public platform: string;
  /** wurde veröffentlicht am Tag X */
  public public_ymd: number;
  public change_log_de: string;
  public change_log_en: string;
  public force: boolean;
  /** Wird ablaufen zum Tag x*/
  public obsolet_ymd: number;
  public notify: boolean;

  public DeserializeType(): void {
    // has no complex type
  }
}
